import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let image_id = useDataValue({
    context: 'patient_image',
    path: 'id',
    viewPath: props.viewPath,
  })
  let setImageSerieId = useDataChange({
    context: 'images_comparison_action',
    path: 'image_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    setImageSerieId(image_id)
  }
}
